import { Box } from "@mui/material";
import MDBox from "components/MDBox";
import MDProgress from "components/MDProgress";
import MDTypography from "components/MDTypography";
import React from "react";
import img from "../../assets/images/illustrations/loading.gif";
import { useSelector } from "react-redux";

const SkLoading = () => {
  const { companyData } = useSelector((data) => data?.isCompany) || {};

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight: "350px",
        py: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80px",
          width: "80px",
        }}
      >
        <img
          src={companyData?.loader ? `${process.env.REACT_APP_URI}/${companyData?.loader}` : img}
          style={{
            height: "100%",
            width: "100%",
            objectFit: "contain",
            display: "block",
            margin: "0 auto",
          }}
          alt="loading"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = img;
          }}
        />
      </Box>
    </Box>
  );
};

export default SkLoading;
